import * as React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import * as XLSX from 'xlsx';
import { Button } from 'react-admin';
import { Description } from '@mui/icons-material';

export default function MonthlyCandidatesByClient({ data: statistics }) {
  const dinamicMonthNameColumns = statistics?.column_titles ? Object.values(statistics?.column_titles) : []
  const dinamicMonthKeyColumns = statistics?.column_titles ? Object.keys(statistics?.column_titles) : []
  const avgCounter = statistics?.avg_counter ?? 12
  const from = statistics.from
  const to = statistics.to
  const clientStatisticRows = statistics?.rows ? Object.values(statistics?.rows) : []

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet([]);
    const header = ['Client Name', ...dinamicMonthNameColumns, 'Average'];
    XLSX.utils.sheet_add_aoa(worksheet, [header], { origin: 'A1' });

    clientStatisticRows.forEach(clientStats => {
      const row = [];
      row.push(clientStats?.client_name ?? '-');
      let total = 0;
      dinamicMonthKeyColumns.forEach(monthKey => {
        const year = parseInt(monthKey.slice(0, 4));
        const month = parseInt(monthKey.slice(4));
        const amount = year in clientStats.column_data && month in clientStats.column_data[year]
          ? clientStats.column_data[year][month]
          : 0;

        row.push(amount);
        total += amount;
      });
      row.push(Math.floor(total / avgCounter));
      XLSX.utils.sheet_add_aoa(worksheet, [row], { origin: -1 });
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Monthly Candidates');
    XLSX.writeFile(workbook, `Monthly_Candidates_${from}_to_${to}.xlsx`);
  };

  return (
    <>
      <Button variant="contained" onClick={exportToExcel} sx={{ marginBottom: 2 }}>
        <Description /> Exportar a Excel
      </Button>
      <TableContainer sx={{overflowY: 'auto', maxWidth: '100%'}} component={Paper}>
        <Table size="small" aria-label="a dense table" sx={{minWidth: 'max-content'}}>
          <TableHead>
            <TableRow>
              <TableCell colSpan={avgCounter + 3} align='center'><strong>Candidatos/Meses ({from} al {to})</strong></TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              {dinamicMonthNameColumns.map(function (text) {
                return (<TableCell><strong>{text}</strong></TableCell>)
              })}
              <TableCell><strong>Average</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {clientStatisticRows.map(function (clientStats) {
              let total = 0
              return (
                <TableRow>
                  <TableCell>{ clientStats?.client_name ?? '-' }</TableCell>
                  {dinamicMonthKeyColumns.map(function (monthKey) {
                    let year = parseInt(monthKey.slice(0, 4))
                    let month = parseInt(monthKey.slice(4))
                    let amount = year in clientStats.column_data && month in clientStats.column_data[year] ? clientStats.column_data[year][month] : 0

                    total += amount

                    return (<TableCell>{amount}</TableCell>)
                  })}
                  <TableCell>{ Math.floor(total / avgCounter) }</TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}